const dateFormatter = new Intl.DateTimeFormat("zh-CN", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const dateTimeFormatter = new Intl.DateTimeFormat("zh-CN", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

/** Unix 毫秒 → `2026/11/02`。 */
export function formatDate(unixMs: number): string {
  if (!Number.isFinite(unixMs)) return "—";
  return dateFormatter.format(new Date(unixMs));
}

/** Unix 毫秒 → `2026/11/02 20:22`，给 title 属性用。 */
export function formatDateTime(unixMs: number): string {
  if (!Number.isFinite(unixMs)) return "—";
  return dateTimeFormatter.format(new Date(unixMs));
}

/** 42310 → `42,310`；空值 → `—`。 */
export function formatPoints(points: number | null | undefined): string {
  if (points === null || points === undefined || !Number.isFinite(points)) return "—";
  return points.toLocaleString("zh-CN");
}

/** 4.5 → `4.5s`，4 → `4s`。 */
export function formatDuration(seconds: number): string {
  if (!Number.isFinite(seconds)) return "—";
  const rounded = Math.round(seconds * 10) / 10;
  return `${Number.isInteger(rounded) ? rounded : rounded.toFixed(1)}s`;
}

/** 108.5 → `1:49`（集时长用 m:ss，元数据一律等宽）。 */
export function formatClock(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return "—";
  const total = Math.round(seconds);
  return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`;
}
